import { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Box,
  IconButton,
  AlertColor,
  Alert,
  Snackbar,
} from "@mui/material";
import KeyTabs from "./KeyTabs";
import ContractorForm from "./ContractorForm";
import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../molecules/PageTitle";
import useFetchData from "../../../hooks/useFetchData";
import { CustomContainer } from "../../../styles/styles";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import NavigateButton from "../../atoms/Button/NavigateButton";
import React from "react";
import {
  ErrorWithRetry,
  LoadingSpinner,
} from "../../molecules/LoadingAndError";

export type FetchedData = {
  autoContractId: number;
  contractId: string;
  contractManagementId: string;
  contractorName: string;
  phoneNumber: string;
  roomNumber: string;
  email: string;
  memo: string;
  isEnabled: boolean;
  eep: string;
  isProximityKeyContract: boolean;
  canSetKeyExpiration: boolean;
  building: {
    autoBuildingId: number;
    buildingId: string;
    buildingManagementId: string;
    buildingName: string;
    buildingAddress: string;
    sdcs: {
      isAalEnabled: boolean;
      autoSdcId: number;
      sdcUuid: any;
      sdcSerialNumber: string;
      doorPlace: string;
    }[];
  };
  keys: {
    eep: string;
    createdAt: string;
    autoKeyId: number;
    keyIndexInContract: number;
    activateId: string;
    password: string;
    sdVersion: string;
    sdVender: string;
    authToken: undefined | string;
    isEnabled: boolean;
    memo: string;
    canCreateDuplicateKey: boolean;
    canManageFelica: boolean;
    activatedAt: undefined | string;
    lastUsedAt: undefined | string;
    expiredAt: string | null;
    isIcmEnabled: boolean;
    icmActivatedAt: string | null;
    icmUserDefinedName: string;
    sdc: {
      autoSdcId: number;
      sdcSerialNumber: string;
      sdcUuid: string;
      doorPlace: string;
    };
  }[];
  icCardKeys: {
    createdAt: string;
    autoIcCardKeyId: number;
    isEnabled: boolean;
    memo: string;
    lastUsedAt: string;
    idm: string;
    keyIndexInContract: number;
    sdc: {
      autoSdcId: number;
      doorPlace: string;
      sdcSerialNumber: string;
      isNfcCertRequired: boolean;
    };
  }[];
};

const ContractorFormPage = () => {
  // const location = useLocation() as { state?: { autoContractId: string } };
  // const autoContractId = location.state?.autoContractId;
  const { autoBuildingId, autoContractId } = useParams();
  const [isEnabled, setIsEnabled] = useState<boolean | undefined>(true);

  const [fetchedData, setFetchedData] = useState<FetchedData>();

  const url = autoContractId
    ? process.env.REACT_APP_API_ENDPOINT +
      "/buildings/" +
      autoBuildingId +
      "/contracts/" +
      autoContractId
    : undefined;

  const fetchedAt = new Date().getTime();
  // call showContract API
  const { data, isLoading, error } = useFetchData<FetchedData>(url);

  useEffect(() => {
    if (data && !Array.isArray(data)) {
      setFetchedData(data);
    }
    console.log("Fetched data:", data);
    if (fetchedData == undefined) {
      setIsEnabled(true);
    } else {
      setIsEnabled(fetchedData?.isEnabled);
    }
  }, [data]);

  useEffect(() => {
    console.log("Updated fetchedData:", fetchedData);
  }, [fetchedData]);

  // アラート
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("success");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    // window.location.reload();//下部アラートが消えた後に画面リロード
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorWithRetry onRetry={() => window.location.reload()} />;
  }

  return (
    <CustomContainer maxWidth={false}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems="center"
          >
            {/* URLにautoContractIdがあるかないかで表示を分岐 */}
            <PageTitle
              title={!autoContractId ? "契約者新規登録" : "契約者詳細・編集"}
            />
            <NavigateButton
              to={"/buildings/" + autoBuildingId + "/contractors"}
              buttonTitle={"契約者一覧"}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <ContractorForm
            isNew={!autoContractId ? true : false} // 新規作成の場合はautoContractIdがundefinedなのでtrue、そうでなければfalse
            fetchedData={fetchedData}
            setFetchedData={setFetchedData}
            setSnackbarOpen={setSnackbarOpen}
            setAlertSeverity={setAlertSeverity}
            setSnackbarMessage={setSnackbarMessage}
            isEnabled={isEnabled}
            setIsEnabled={setIsEnabled}
          />
        </Grid>
        {fetchedData && (
          <Grid item xs={12}>
            <KeyTabs
              fetchedData={fetchedData}
              isEnabled={isEnabled}
              fetchedAt={fetchedAt}
              setSnackbarOpen={setSnackbarOpen}
              setAlertSeverity={setAlertSeverity}
              setSnackbarMessage={setSnackbarMessage}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          {/* <RegisteredKeysTable registeredKeys={sampleRegisteredKeys} /> */}
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={alertSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </CustomContainer>
  );
};

export default ContractorFormPage;
